export default "__VITE_ASSET__6b16b9b6__"